export let addToFavoritesText = "kTLuP";
export default {addToFavoritesText};